"use client";

import { useEffect } from "react";

export function useResizeOnboardingEmbed(isEmbed: boolean, width: number, height: number) {
  useEffect(() => {
    if (!isEmbed) return;

    window.parent.postMessage({ type: "onboarding:resize", width, height }, "*");
  }, [isEmbed, width, height]);
}
